import { render } from "./EnUnit3-4.vue?vue&type=template&id=0ffe745e&scoped=true"
import script from "./EnUnit3-4.vue?vue&type=script&lang=js"
export * from "./EnUnit3-4.vue?vue&type=script&lang=js"

import "../assets/css/en-common.css?vue&type=style&index=0&id=0ffe745e&scoped=true&lang=css"
import "../assets/css/en/Unit3-4.css?vue&type=style&index=1&id=0ffe745e&scoped=true&lang=css"
import "../assets/css/audio-comp.css?vue&type=style&index=2&id=0ffe745e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ffe745e"]])

export default __exports__